import { LogService } from '@hub/shared'
import React from 'react'
import * as ReactDOMClient from 'react-dom/client'
import singleSpaReact from 'single-spa-react'
import './i18n.outside'
import Root from './root.component'

const lifecycles = singleSpaReact({
  React,
  ReactDOMClient,
  rootComponent: Root,
  errorBoundary(err, info, props) {
    const logService = new LogService()
    logService.init('HUB Outside')
    logService?.error({
      message: `ERROR Outside: ${err} ${info?.componentStack}`,
      error: info?.componentStack,
    })
    history.pushState({}, '', '/error/general-error')
    return <div></div>
  },
})

export const { bootstrap, mount, unmount } = lifecycles
